import { render } from "./NotificationLogo.vue?vue&type=template&id=64836726"
import script from "./NotificationLogo.vue?vue&type=script&lang=js"
export * from "./NotificationLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__